import { getAccessToken } from '../localStorage';

export const downloadFile = async ({
  fileUrl,
  filename = 'Document.pdf',
}: {
  fileUrl: string;
  filename?: string;
}) => {
  try {
    const response = await fetch(fileUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to download file');
    }

    // Convert response to Blob
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element
    const a = document.createElement('a');
    a.href = url;
    a.download = filename; // Replace with actual file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};
